import React from 'react';
import { Link } from "react-router-dom";

export default function NavLink({ to, text, onClose }) {
  return (
    <Link
      className="text-base font-medium text-white hover:text-white hover:underline underline-offset-4 transition-all duration-200 hover:scale-105"
      to={to}
      onClick={onClose}
    >
      {text}
    </Link>
  );
}
